// turns logic within className into a string to make sure no 'undefined' etc. show up in the DOM
export const cx = (...classes: Array<string | number | boolean | object | undefined>) =>
  classes.filter(Boolean).join(' ')
